<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.inquiriesMy'), $t('text.list')]">
        <el-button
          v-if="Permit.canActions('inquiryInquiriesManage')"
          type="success"
          size="mini"
          @click="add"
          >+ {{ $t("text.create") }}</el-button
        >
      </breadcrumb>
    </div>
    <div class="search">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.serialNo"
            :placeholder="$t('inquiry.serialNo')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <vxe-table
        :data="records"
        :loading="loading"
        id="inquiriesTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="80"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('inquiry.serialNo')"
          width="150"
        >
          <template v-slot="{ row }">
            <span class="blue" @click="showRow(row)">{{ row.serialNo }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          width="100"
        />
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          width="60"
        />
        <vxe-table-column
          field="inquiryAt"
          :title="$t('inquiry.inquiryAt')"
          width="110"
        />
        <vxe-table-column
          field="expirateAt"
          :title="$t('inquiry.expirateAt')"
          width="110"
        />
        <vxe-table-column
          field="minPrice"
          :title="$t('inquiry.minPrice')"
          width="100"
        >
          <template v-slot="{ row }">{{ row.minPrice | currency }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="lastQuotePrice"
          :title="$t('inquiry.lastPrice')"
          width="100"
        >
          <template v-slot="{ row }">
            {{ row.lastPrice | currency }}
          </template>
        </vxe-table-column>
        <vxe-table-column field="type" :title="$t('inquiry.type')" width="80">
          <template v-slot="{ row }">{{
            $t("inquiryTypes." + row.type)
          }}</template>
        </vxe-table-column>
        <vxe-table-column field="explain" :title="$t('text.explain')">
          <template v-slot="{ row }">
            <raw-html-limit-number :content="row.explain" :number="20" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          v-if="Permit.canActions('inquiryInquiriesManage')"
          field="action"
          :title="$t('text.action')"
          width="100"
        >
          <template v-slot="{ row }">
            <!-- v-if="row.lastQuoteAt == null " -->

            <el-button type="text" size="mini" @click="edit(row)">{{
              $t("text.edit")
            }}</el-button>
            <el-button type="text" size="mini" @click="deleteRow(row)">{{
              $t("text.delete")
            }}</el-button>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>

    <!-- 编辑 -->
    <el-dialog
      :title="$t('text.edit')"
      :visible.sync="editDF"
      :close-on-click-modal="false"
      width="50%"
    >
      <el-form ref="editObjForm" :model="editObj" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item
              :prop="'serialNo'"
              :label="$t('inquiry.serialNo')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('inquiry.serialNo')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input size="small" v-model.trim="editObj.serialNo" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :prop="'productNo'"
              :label="$t('product.productNo')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('product.productNo')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-autocomplete
                size="small"
                v-model.trim="editObj.productNo"
                :fetch-suggestions="querySearchProductNo"
                :trigger-on-focus="false"
                @select="handleSelectProductNoEdit"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              :prop="'quantity'"
              :label="$t('text.quantity')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('text.quantity')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input size="small" v-model.trim="editObj.quantity" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :prop="'expirateAt'"
              :label="$t('inquiry.expirateAt')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('inquiry.expirateAt')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-date-picker
                size="small"
                v-model="editObj.expirateAt"
                type="date"
                style="width: 100%"
                :picker-options="pickerTodayAfterTime"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <fieldset class="mgb15">
          <legend>
            {{ $t("product.images") }}
            <svg-icon icon-class="link" @click="linkImage('edit')" />
          </legend>
          <dropzone size="small" v-model="editObj.images" multiple />
        </fieldset>
        <fieldset class="mgb15">
          <legend>{{ $t("text.explain") }}</legend>
          <el-input
            size="small"
            v-model.trim="editObj.explain"
            type="textarea"
            :rows="2"
          />
        </fieldset>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="editDoing"
          size="small"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('action.linkImage')"
      :visible.sync="linkImageDF"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form ref="linkImageForm" :model="linkImageObj">
        <el-form-item
          :prop="'linkImageStr'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('action.linkImage')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="linkImageObj.linkImageStr"
            :placeholder="$t('prompt.linkImageExplain')"
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 10 }"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="linkImageDoing"
          size="small"
          @click="linkImageSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="linkImageDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 新增 -->
    <el-dialog
      :title="$t('text.create')"
      :visible.sync="addDF"
      :close-on-click-modal="false"
      width="50%"
    >
      <el-form ref="addObjForm" :model="addObj" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('inquiry.type')" :prop="'type'">
              <el-radio-group v-model="addObj.type">
                <el-radio label="private">{{
                  $t("inquiryTypes.private")
                }}</el-radio>
                <el-radio label="public">{{
                  $t("inquiryTypes.public")
                }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="$t('inquiry.serialNo')"
              :prop="'serialNo'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('inquiry.serialNo')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input size="small" v-model.trim="addObj.serialNo" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :prop="'productNo'"
              :label="$t('product.productNo')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('product.productNo')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-autocomplete
                size="small"
                v-model.trim="addObj.productNo"
                :fetch-suggestions="querySearchProductNo"
                :trigger-on-focus="false"
                style="width: 100%"
                @select="handleSelectProductNo"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="$t('text.quantity')"
              :prop="'quantity'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('text.quantity')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input size="small" v-model.trim="addObj.quantity" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('inquiry.expirateAt')"
              :prop="'expirateAt'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('inquiry.expirateAt')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-date-picker
                size="small"
                v-model="addObj.expirateAt"
                type="date"
                style="width: 100%"
                :picker-options="pickerTodayAfterTime"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <fieldset class="mgb15">
          <legend>
            {{ $t("product.images") }}
            <svg-icon icon-class="link" @click="linkImage('add')" />
          </legend>
          <dropzone v-model="addObj.images" multiple />
        </fieldset>
        <fieldset class="mgb15">
          <legend>{{ $t("text.explain") }}</legend>
          <el-input
            size="small"
            v-model.trim="addObj.explain"
            type="textarea"
            :rows="2"
          />
        </fieldset>
        <fieldset v-if="addObj.type == 'private'" class="mgb15">
          <legend>
            {{ $t("menu.suppliers") }}
            &nbsp;&nbsp;
            <el-checkbox
              size="small"
              v-model="checkAllSuppliers"
              :indeterminate="isIndeterminateSuppliers"
              @change="handleCheckAllSuppliersChange"
              >{{ $t("action.checkAll") }}</el-checkbox
            >
          </legend>
          <el-checkbox-group
            size="small"
            v-model="checkedSuppliers"
            @change="handleCheckedSuppliersChange"
          >
            <el-checkbox
              size="small"
              v-for="supplier in suppliersFilter"
              :key="supplier.id"
              :label="supplier"
              style="width: 100px"
              >{{ Util.limitText(supplier.name, 5) }}</el-checkbox
            >
          </el-checkbox-group>
        </fieldset>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addDoing"
          size="small"
          @click="addSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <drawer
      :title="$t('text.view')"
      :visible.sync="showDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRowId" />
    </drawer>
  </div>
</template>
<script>
import Vue from "vue";
// import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import Thumbnail from "@/components/Thumbnail";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import Dropzone from "@/components/Dropzone";
import Util from "@/utils/index.js";
import Inquiry from "@/api/inquiry.js";
import Product from "@/api/product.js";
import Supplier from "@/api/supplier.js";
import Show from "./show.vue";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    Thumbnail,
    Dropzone,
    RawHtmlLimitNumber,
    Show,
  },
  data() {
    return {
      pickerTodayAfterTime: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      Util: Util,

      searchForm: {
        serialNo: null,
        productNo: null,
      },
      sorter: {
        sortBy: "inquiries_id",
        sortIndicator: "desc",
      },
      Util: Util,
      products: [],
      // 编辑
      editDF: false,
      row: null,
      editObj: {
        serialNo: null,
        productNo: null,
        quantity: null,
        expirateAt: null,
        images: null,
        explain: null,
      },
      editDoing: false,
      // 图片链接
      linkImageDF: false,
      linkImageObj: {
        linkImageStr: null,
      },
      linkType: null,
      linkImageDoing: false,
      // 新增
      addDF: false,
      suppliersFilter: [],
      addObj: {
        type: "private",
        serialNo: null,
        images: null,
        productNo: null,
        quantity: 1,
        expirateAt: null,
        explain: null,
        inquiryItems: [],
      },
      isIndeterminateSuppliers: false,
      checkedSuppliers: [],
      checkAllSuppliers: false,
      addDoing: false,
      //
      showDF: false,
      currentRowId: null,
    };
  },
  computed: {
    implicit() {
      return {
        actor: "inquirier",
      };
    },
  },
  created() {
    const self = this;
  },
  methods: {
    //
    showRow(row) {
      this.currentRowId = row.id;
      this.showDF = true;
    },
    // 新增
    add() {
      const self = this;
      self.addObj.type = "private";
      self.addObj.serialNo = Util.serialNo();
      self.addObj.images = null;
      self.addObj.productNo = null;
      self.addObj.expirateAt = null;
      self.addObj.explain = null;
      self.addObj.InquiryItems = [];
      Supplier.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.suppliers = res.data;
          self.suppliersFilter = self.suppliers.filter(
            (s) => s.sourceTenantId != null
          );
          self.addDoing = false;
          self.addDF = true;
        } else {
          self.sysError();
        }
      });
    },
    handleSelectProductNo(item) {
      const self = this;
      self.addObj.productNo = item.productNo;
      self.addObj.images = item.images;
    },
    handleCheckAllSuppliersChange(val) {
      this.checkedSuppliers = val ? this.suppliersFilter : [];
    },
    handleCheckedSuppliersChange(value) {
      const checkedCount = value.length;
      this.checkAllSuppliers = checkedCount === this.suppliersFilter.length;
      this.isIndeterminateSuppliers =
        checkedCount > 0 && checkedCount < this.suppliersFilter.length;
    },
    addSubmit() {
      const self = this;
      if (
        self.addObj.type === "private" &&
        self.checkedSuppliers.length === 0
      ) {
        self.$message({
          message: this.$t("prompt.atLeastOneSupplier"),
          type: "warning",
        });
        return;
      }
      self.$refs.addObjForm.validate((valid) => {
        if (valid) {
          if (!Util.regexQuantity(self.addObj.quantity)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("text.quantity")]),
              type: "warning",
            });
            return;
          }
          self.addObj.inquiryItems = self.checkedSuppliers.map((c) => {
            return { supplierId: c.id, supplierTenantId: c.sourceTenantId };
          });
          self.addObj.expirateAt = Util.formatDate(self.addObj.expirateAt);
          self.addDoing = true;
          Inquiry.insertBatch([self.addObj]).then(function (res) {
            self.addDoing = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.inquirySuccess"),
                type: "success",
              });
              self.loadData();
              self.addDF = false;
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        Inquiry.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 图片链接
    linkImage(type) {
      this.linkImageDF = true;
      this.linkImageObj.linkImageStr = null;
      this.linkType = type;
    },
    linkImageSubmit() {
      const self = this;
      this.$refs.linkImageForm.validate((valid) => {
        if (valid) {
          const linkImageArr = this.linkImageObj.linkImageStr.split("\n");
          const linkImageArrFilter = linkImageArr.filter((a) => a != null);
          if (this.linkType === "add") {
            if (self.addObj.images == null) {
              self.addObj.images = linkImageArrFilter.join(";");
            } else {
              self.addObj.images =
                self.addObj.images + ";" + linkImageArrFilter.join(";");
            }
          } else {
            if (self.editObj.images == null) {
              self.editObj.images = linkImageArrFilter.join(";");
            } else {
              self.editObj.images =
                self.editObj.images + ";" + linkImageArrFilter.join(";");
            }
          }

          this.linkImageDF = false;
        } else {
          return false;
        }
      });
    },
    // 编辑
    edit(row) {
      const self = this;
      Inquiry.findItemsById(row.id).then(function (res) {
        if (res.status === 200) {
          const items = res.data.filter((r) => r.quotation != null);
          if (items.length === 0) {
            self.row = row;
            self.editObj.serialNo = row.serialNo;
            self.editObj.productNo = row.productNo;
            self.editObj.quantity = row.quantity;
            self.editObj.expirateAt = row.expirateAt;
            self.editObj.images = row.images;
            self.editObj.explain = row.explain;
            self.editDoing = false;
            self.editDF = true;
          } else {
            self.$message({
              message: self.$t("prompt.exitQuotationNotEdit"),
              type: "warning",
            });
          }
        } else {
          self.sysError();
        }
      });
    },
    querySearchProductNo(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      Product.vagueFindByProductNo({ productNo: queryString }).then(function (
        res
      ) {
        self.products = res.data;
        if (self.products.length !== 0) {
          for (const p of self.products) {
            Vue.set(p, "value", p.productNo);
          }
        }
        cb(self.products);
      });
    },
    handleSelectProductNoEdit(item) {
      const self = this;
      self.editObj.productNo = item.productNo;
      self.editObj.images = item.images;
    },
    editSubmit() {
      const self = this;
      self.$refs.editObjForm.validate((valid) => {
        if (valid) {
          if (!Util.regexQuantity(self.editObj.quantity)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("text.quantity")]),
              type: "warning",
            });
            return;
          }
          self.editObj.expirateAt = Util.formatDate(self.editObj.expirateAt);
          self.editDoing = true;
          Inquiry.update(self.row.id, self.editObj).then(function (res) {
            self.editDoing = false;
            self.editDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    dataProvider(params) {
      return Inquiry.search(params);
    },
  },
};
</script>
<style scoped>
</style>